<template>
  <div class="topnav-box">
    <nav class="topnav width-full px-4">
      
      <div class="d-flex flex-items-center align-items-center flex-wrap">

        <!-- logo -->
        <router-link
          :to="{name: 'home'}"
          class="d-inline-block usn"
          >
          <span>
            <img src="/static/img/logo_jgn.png" style="width: 90px;">
          </span>
          <br>
          <img src="/static/img/logo_jgn_on_binance.png" class="ml-1" style="width: 160px;">
        </router-link>

        <!-- search -->
        <FrameSearchBar class="ml-3 mb-none" style="width: 350px;" :key="'pc'" />

        <span 
          class="sp-header-icon pc-none cp ml-auto py-2" 
          @click="status_mb_search_pad_box_show = true"
          >
          <i class="fa fa-search" style="color: #eee;"></i>
        </span>
        <div :class="['mb-search-pad-box pc-none',{'on': status_mb_search_pad_box_show}]">
          <div class="p-4">
            <FrameSearchBar @closeSearchPad="status_mb_search_pad_box_show = false" :key="'mb'"/>
          </div>
        </div>

        <!-- mobile menu -->
        <span 
          @click="toggleMobileHeaderPad()"
          class="sp-header-icon pc-none cp ml-3 py-2"
           style="color: #eee;"
          >
          <i v-if="!status_mobile_header_pad_show" class="fas fa-bars"></i>
          <i v-if="status_mobile_header_pad_show" class="fas fa-times"></i>
        </span>
        <FrameMobileHeaderPad 
          :class="['pc-none',{'on': status_mobile_header_pad_show}]"
          @hideMobileHeaderPad="status_mobile_header_pad_show = false"
        />

        <!-- nav -->
        <FrameHeaderNav class="ml-5 pl-1 d-flex mb-none"/>
        
        <!-- media links & account-->
        <div class="d-flex align-items-center ml-auto mb-none">

          <FrameBtnUserLogin class="mr-4"/>

          <!-- account -->
          <FrameBtnAccount/>

          <!-- lang -->
          <FrameHeaderLangSelect class="ml-4 mb-ml-auto" style="color: #eee;"/>

        </div>
      </div>



      <CpBlockSignup :mark_ui_call="mark_sign_ui_call"/>

      <UiModal :open="status_show_qrcode_wechat" @close="status_show_qrcode_wechat = false" class="size-sm">
        <div class="p-5 tac">
          <h4 class="mb-2">
            {{lg('',{
              en: 'Scan with Wechat',
              zh: '请用微信扫码',
            })}}
          </h4>
          <div style="min-height: 200px;">
            <img src="/static/pic/qrcode/qrcode_wechat_a.png" style="max-width: 200px;">
          </div>
        </div>
      </UiModal>

    </nav>
  </div>
</template>

<script>
import bus from '@/bus.js'



export default {
  data() {
    return {
      status_mobile_header_pad_show: false,

      status_mb_search_pad_box_show: false,

      status_show_qrcode_wechat: false,

      mark_sign_ui_call: 0,
    };
  },
  computed: {
    
  },
  methods: {
    toggleMobileHeaderPad(){
      let v = this
      v.status_mobile_header_pad_show = !v.status_mobile_header_pad_show
    },
  },
  created(){

    
    // bus
    bus.headervue = this
  },
};
</script>

<style lang="scss" scope>
  @import '@/assets/css/vars.scss';

  .topnav-box{
    height: $h_header;
    display: flex;
    align-items: center;
    position: sticky;
    z-index: 9;
    top: 0px;
    border-bottom: 1px solid #222;
    // kk:bgcolor reset
    // box-shadow: 0 0 8px #000;
    
    .sp-header-icon{
      display: inline-block;
      text-align: center;
      min-width: 35px;
    }
  }

  .mb-search-pad-box{
    display: none;
    position: fixed;
    top: 0;
    left:0;
    right: 0;
    bottom: 0;
    background-color: var(--bg-color);
    z-index: 1;

    &.on{
      display: block;
    }
  }


</style>
